import axiosInstance from "./axiosInstance";

export const fetchSubscriptionSettings = () => axiosInstance.get("/superadmin/subscription-settings");

export const updateSubscriptionSettings = (data) => axiosInstance.put("/superadmin/subscription-settings", data);
